module.exports = __webpack_public_path__ + "static/img/CloseFee.1422913a.png";